import React from "react"
import _, { get, isNull, isUndefined } from "lodash"
import FormLink from "./FormLink"

const buildCondition = (variable, value, [operator], result) => {
  if (variable && operator) {
    if (value && result) {
      switch (typeof result[variable]) {
        case "number":
        case "boolean":
          return `get(result, "${variable}") ${operator} ${value}`
        case "string":
        default:
          return `get(result, "${variable}") ${operator} "${value}"`
      }
    } else {
      return `typeof result.${variable} ${operator} "undefined"`
    }
  } else {
    return operator
  }
}

// Although result seems to be unused, it isnt. It is being used in the formed condition
function evaluateCondition(result, condition) {
  let evaluationResult = true
  try {
    // eslint-disable-next-line
    evaluationResult = eval(condition)
  } catch (_error) {
    console.error("Error in evaluation:", condition)
    return false
  }
  return evaluationResult
}

export default ({ selectForm, formData, transformFormId, visibleForms }) => {
  return (
    <div>
      {visibleForms.map(form => {
        return (
          <FormLink
            name={form.name}
            description={form.description}
            isDone={false}
            onClick={() => {
              selectForm(
                transformFormId(form.forms._id),
                form.submissionIdentifier,
                form.forms.storePath
              )
            }}
            checked={
              !isUndefined(get(formData, form.forms.storePath)) &&
              !isNull(get(formData, form.forms.storePath))
            }
            disabled={
              !isUndefined(get(formData, form.forms.storePath)) &&
              !isNull(get(formData, form.forms.storePath))
            }
          ></FormLink>
        )
      })}
    </div>
  )
}
